import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const BigStar = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="m6.084 21.193 1.574-6.734-5.226-4.516 6.878-.6L12.001 3l2.703 6.343 6.866.6-5.226 4.516 1.585 6.734-5.923-3.58-5.922 3.58Z"
    />
  </Svg>
)
export default BigStar
